export default __webpack_public_path__ + "static/media/background.d527a4fb.png";